module.exports = __webpack_public_path__ + "svg/new-dankort-small.02673295200a8428e27923711bdda7ce.svg";